import { useState } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { AuraMark } from "@/components/site/AuraMark";

export const AdminLogin = () => {
  const { t } = useLang();
  const { setUser } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/admin-login", form);
      setUser(data);
    } catch (err) {
      setError(errMsg(err, t.common.error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5 pt-24 pb-12" data-testid="admin-login-page">
      <form onSubmit={submit} className="glass w-full max-w-md rounded-[2rem] p-8 md:p-10 space-y-4">
        <AuraMark className="w-12 h-12" />
        <h1 className="pt-4 font-display text-3xl font-extrabold text-white">{t.admin.loginTitle}</h1>
        <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder={t.admin.email} className="field" data-testid="admin-email-input" />
        <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder={t.admin.password} className="field" data-testid="admin-password-input" />
        {error && <p className="text-sm text-rose-300" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn-chrome w-full rounded-full py-3 font-semibold text-[#050713] disabled:opacity-60" data-testid="admin-login-submit">
          {busy ? "..." : t.admin.signIn}
        </button>
      </form>
    </main>
  );
};
